<div class="su-scroll">
<div class="row">
  <div class="col-12 p-0 pl-1 border-bottom headersize" style="font-size:12px;font-weight:600;">
    Select the Subjects Applicable to the Study Unit
  </div>
</div>
<div class="row">
  <div class="col-7">
    <div class="d-flex" style="font-size:12px;font-weight:600;">
      <div class="headersize">Subjects</div>
      <!-- <div class="p-0 label-red">*</div> -->
    </div>
  </div>
  <div class="col-5">

  </div>
</div>

  <div class="row">
    <div class="row tree-row" *ngFor="let item of MajorTopics">
      <div class="col-12 d-flex align-items-baseline">
        <div class="px-1 tree-btn-1">
          <button type="button" class="tree-btn" *ngIf="item.ChildNodeExistInd === 'Y'" (click)="getSubjectTree(item)">
            <i class="fa fa-angle-right" *ngIf="!item.Data"></i>
            <i class="fa fa-angle-down" *ngIf="item.Data"></i>
          </button>
        </div>

        <app-tree-content [Text]="item.Name" [status]="item.Status_Code" ID="item.ID"></app-tree-content>
        <div class="d-flex align-items-center">
          <!-- ✅ Checkbox -->
          <input
            type="checkbox"
            class="form-check-input-sm me-2"
            [(ngModel)]="item.checked"
            [disabled]="enableDisableCheckBox(item)"
            (change)="onCheckboxChange(item)"
            *ngIf="item.ChildNodeExistInd === 'N'"
          />

          <!-- ✅ Testing Probability Type List -->
          <div class="testing-probability-type" *ngIf="item.checked">

            <ng-container *ngFor="let type of TestingProbabilityType">
              <label class="me-2">
                <input
                  type="radio"
                  name="testingProbability_{{ item.ID }}"
                  [value]="type.Code"
                  [(ngModel)]="item.TestingProbabilityTypeCode"
                  (change)="onTestingProbabilityChange(item, type.Code)"
                />
                {{ type.Description }}
              </label>
            </ng-container>
          </div>
        </div>

    </div>

      <div *ngIf="item.Data" class="ms-4">
        <app-content-studyunit-topics-node
          [treeNodes]="item.Data"
          [AvailableStudyUnits]="AvailableStudyUnits"
          [selectedNodes]="selectedNodes"
          [TestingProbabilityType]="TestingProbabilityType"
          (selectedNodesChange)="onSelectedNodesChange($event)">
        </app-content-studyunit-topics-node>
      </div>

    </div>
  </div>
  <div class="su-sticky-footer">
    <div class="d-flex justify-content-end gap-2">
      <button
        type="button"
        class="btn btn-sm bl-btn"
        (click)="SaveStudyUnitTopics()"
        [disabled]="!selectedNodes || selectedNodes.length === 0">
        Save
      </button>

      <button
        type="button"
        class="btn btn-sm bg-light border"
        (click)="Cancel()">
        Cancel
      </button>
    </div>
  </div>

</div>
